export default {
  // 绑定类型选项
  drone: '无人机',
  dog: '机器狗',

  // 无人机绑定
  droneBinding: {
    // 基础
    loading: '加载中...',
    project: '项目',
    selectProject: '请选择项目',

    // 表格列
    routeName: '航线名称',
    payload: '负载',
    updateTime: '更新时间',
    operation: '操作',

    // 操作按钮
    bindAlgorithm: '绑定算法',
    clearBinding: '清空绑定',

    // 弹窗
    algorithmModalTitle: '算法模型与点位绑定',
    addModel: '添加模型',
    noBindingData: '暂无绑定数据，请先添加模型。',

    // 表格列（弹窗内）
    modelName: '模型名称',
    selectModel: '请选择模型',
    skipFrame: '跳帧',
    confidence: '置信度',
    resolution: '分辨率',
    startPoint: '开始点位',
    endPoint: '结束点位',
    actions: '动作',
    selectActions: '请选择动作',

    // 按钮操作
    cancel: '取消',
    confirm: '确定',

    // 提示消息
    routeInfoMissing: '航线信息缺失',
    clearedBinding: '已清空绑定',
    selectValidModel: '请为每行选择有效模型',
    bindSuccess: '绑定算法成功',
    selectProjectFirst: '请先选择项目',
    routeIdInvalid: '航线 ID 无效',

    // 确认对话框
    clearBindingTitle: '确认清空绑定？',
    clearBindingContent: '将清除「{name}」的全部算法绑定关系，操作不可撤销。',
    confirmClear: '确认清空',

    // 动作选项
    voice: '语音喊话',
    photo: '拍照',
    flash: '红蓝爆闪',
    ir: '探照灯',
  },

  // 机器狗绑定
  dogBinding: {
    // 基础
    loading: '加载中...',
    mapName: '地图名称',
    mapNamePlaceholder: '请输入地图名称',
    query: '查询',

    // 表格列
    routeName: '路线名称',
    deviceSn: '设备 SN',
    createTime: '创建时间',
    operation: '操作',

    // 操作按钮
    bindAlgorithm: '绑定算法',
    clearBinding: '清空绑定',

    // 弹窗
    algorithmModalTitle: '算法模型与点位绑定',
    addModel: '添加模型',
    noBindingData: '暂无绑定数据，请先添加模型。',

    // 表格列（弹窗内）
    modelName: '模型名称',
    selectModel: '请选择模型',
    skipFrame: '跳帧',
    confidence: '置信度',
    resolution: '分辨率',
    startPoint: '开始点位',
    endPoint: '结束点位',
    actions: '动作',
    selectActions: '请选择动作',

    // 按钮操作
    cancel: '取消',
    confirm: '确定',

    // 提示消息
    mapInfoMissing: '地图信息缺失',
    clearedBinding: '已清空绑定',
    selectValidModel: '请为每行选择有效模型',
    bindSuccess: '绑定算法成功',
    mapIdInvalid: '地图 ID 无效',
    loadPointsFailed: '加载地图点位失败',
    noMapPoints: '当前地图暂无点位，请先在地图管理中维护点位',
    loadBindingFailed: '加载绑定数据失败',

    // 确认对话框
    clearBindingTitle: '确认清空绑定？',
    clearBindingContent: '将清除「{name}」的全部算法绑定关系，操作不可撤销。',
    confirmClear: '确认清空',

    // 动作选项
    voice: '语音喊话',
    pause: '暂停',
    speedDown: '减速',
    takePhoto: '拍照',
  },
}
